<template>
  <div>
      <el-cascader
        style="width:300px;"
        :options="datas"
        :props="props"
        clearable
        v-model="data"
        :show-all-levels="isShowAllLevels"
      ></el-cascader>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { cascaderOptionsOwnApi } from "@/api/module/classunit/classunit";

export default {
  name: "ClassUnitCascader",
  
  mixins: [BaseVue],
  
  props: {
    showAll: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      props: { 
        multiple: false, 
        checkStrictly: true 
      }, // 是否多选
      isShowAllLevels: false,
      data: "",
      datas: [],
      value: "" // 初始的默认选项
    };
  },
  
  methods: {
    updateVal(id) {
      console.log("updateVal : " + id);
      this.value = id;
    },
    
    init() {
      this.value = "";
    },
    
    initData(val) {
      this.data = val;
      console.log("val", val);
    },
    
    callApi(data) {
      cascaderOptionsOwnApi()
        .then(response => {
          this.datas = response;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  
  mounted() {
    let data = {
      status: 0
    };

    if (this.isRoleinfo.hasPer10012 || 
        this.isRoleinfo.hasPer10011 || 
        this.isAdmin) {
      this.callApi(data);
    }
  },
  
  watch: {
    data: {
      handler() {
        // console.log("on value changed", this.value);
        this.$emit("onValueChanged", this.data);
      }
    }
  }
};
</script>


<style scoped>
.title {
  font-size: 13px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>